module.exports = __webpack_public_path__ + "img/home-w.f0d20e35.svg";